export default __webpack_public_path__ + "static/media/widget_watchbox_vpmndx1d_sell.7487d0b3.mp3";